module.exports = __webpack_public_path__ + "static/stm-seo-64ba1eee0319a563f540c3ff4b4d11ad.png";